import * as React from "react"

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192" {...props}>
      <g
        data-name="chat"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      >
        <path
          d="M143.24 75.28c.33-8.71-4.59-16.28-5.33-17.34a49.17 49.17 0 00-14.17-14.63 64.1 64.1 0 00-20.1-9.1 77.49 77.49 0 00-47.49 2.92 65.25 65.25 0 00-19 11.47A50.67 50.67 0 0024.5 64.9a40.61 40.61 0 00-4 19.66 39.69 39.69 0 002.69 12.54 43.15 43.15 0 006.41 11 50.84 50.84 0 009.4 9.08 66.62 66.62 0 0011.49 6.12c-5.25 9-14.25 14.5-14.35 14.55a3.78 3.78 0 001.62 7c1.82.14 3.64.22 5.46.22a65.12 65.12 0 0010.62-.87A64.22 64.22 0 0065 141.31c.18-.06 4.25-1.54 15.2-7.5"
          stroke="#333"
        />
        <path
          d="M171.55 109.64a32.33 32.33 0 00-4.81-15.36 37.91 37.91 0 00-7-8.31l-.12-.1a62.16 62.16 0 00-17.9-10h-.15l-2.19-.68a61.23 61.23 0 00-37.64 2.31 52.15 52.15 0 00-15.11 9.16 40.67 40.67 0 00-10.1 13 32.79 32.79 0 00-3.27 15.85 32.34 32.34 0 004.85 15.32 39.48 39.48 0 0011.33 11.8 50.46 50.46 0 0016 7.25 59.35 59.35 0 0018.29 1.89 55.43 55.43 0 005.67 3.23 52.44 52.44 0 009 3.38 48.81 48.81 0 0011 1.75h2.13a51.2 51.2 0 0010.62-1.11 3.78 3.78 0 001.14-7c-3.69-2.15-8.69-6.19-10.33-9.61a48.42 48.42 0 006.42-5.08 42.37 42.37 0 006.74-8.13 35.53 35.53 0 004.2-9.39 32.55 32.55 0 001.23-10.17z"
          stroke="#e60000"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
